export function setSpecificTimezoneToDate(date: Date, timeZone: string): Date {
    // Example:
    //      selected date and time was: 2024-04-19 23:30
    //      local timeZone: Buenos Aires (GMT-03)
    //      so date from args will be: 2024-04-20T02:30:00.000Z (UTC)
    //      spot timeZone (the one as an arg): America/Phoenix (GMT-07)

    //      Expected result: 2024-04-20T06:30:00.000Z (UTC) which == 2024-04-19 23:30 (GMT-07)

    // First we get the offset (as string) from timeZone and UTC
    const longOffsetFormatter = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'longOffset' });
    const longOffsetString = longOffsetFormatter.format(date); // example: '4/19/2024, GMT-07:00'
    const gmtOffset = longOffsetString.split('GMT')[1]; // We take the '-07:00'

    // Then, before using the string offset we make the correction with the local offset
    const localOffset = date.getTimezoneOffset();
    const adjustedDateWithLocalOffset = new Date(date.getTime() - localOffset * 60000);

    // Finally we create a new string date with the adjusted date with local offset and expected timezone
    // Following the example adjustedDate will = 2024-04-19T23:30:00.000-07:00
    const adjustedDate = adjustedDateWithLocalOffset.toISOString().split('Z')[0] + gmtOffset;
    return new Date(adjustedDate);
}
